import { getFilesPreviewIsPublicLinkSelector } from "features/files-preview/model/selectors/filesPreviewSelectors"
import { getFilesPublicLinkPermissionsGroupsSelector } from "features/public-link-files/selectors/publicLinkFilesSelectors"
import { useAppSelector } from "shared/config/store"

export const useGetEnablePermission = () => {
  const permissionsGroups = useAppSelector(getFilesPublicLinkPermissionsGroupsSelector)
  const isPublicLink = useAppSelector(getFilesPreviewIsPublicLinkSelector)

  const checkPermission = (permissionId: string) => {
    if (!isPublicLink) return true

    return permissionsGroups?.find((group) => group.id === permissionId)?.enabled ?? false
  }

  return {
    isDownloadEnabled: checkPermission('download_fs_nodes'),
    isUploadEnabled: checkPermission('upload_fs_nodes'),
    isEditContentEnabled: checkPermission('edit_fs_nodes'),
    isCreateCommentsEnabled: checkPermission('create_comments'),
    isFsNodeVersionsEnabled: checkPermission('get_fs_node_versions'),
  }
}